import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import axios from "axios";
import { BASE_API_URL } from "../api/const";

// Тип пропсов для Register
interface RegisterProps {
  onClose: () => void;           // функция закрытия диалога
  onRegisterSuccess: () => void; // функция при успешной регистрации
}

const Register: React.FC<RegisterProps> = ({ onClose, onRegisterSuccess }) => {
  // Локальные состояния для полей формы
  const [login, setLogin] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  // Обработчик регистрации
  const handleRegister = async () => {
    try {
      // Отправляем POST-запрос на регистрацию пользователя
      const response = await axios.post(`${BASE_API_URL}/user/register`, {
        login,
        email,
        password,
      });

      // Распаковываем данные из ответа
      const { success, token } = response.data;

      // Если регистрация успешна — сохраняем логин
      if (success) localStorage.setItem("mediateka.Login", login);

      // Если есть токен — сохраняем его и вызываем колбеки
      if (success && token) {
        localStorage.setItem("mediateka.Token", token);
        onRegisterSuccess();
        onClose();
      } else {
        alert(
          "Регистрация прошла, но токен не получен. Ожидайте подтверждения."
        );
        onClose();
      }
    } catch (error: any) {
      // В случае ошибки показываем сообщение и очищаем поля
      const errorMessage =
        error.response?.data?.error?.message || "Произошла ошибка при регистрации";
      alert(`Ошибка регистрации: ${errorMessage}`);
      setLogin("");
      setPassword("");
      setEmail("");
    }
  };

  return (
    <Box p={2} display="flex" flexDirection="column" gap={2}>
      <TextField
        label="Login"
        value={login}
        onChange={(e) => setLogin(e.target.value)}
        fullWidth
      />
      <TextField
        label="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
      />
      <TextField
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
      />
      <Button variant="contained" onClick={handleRegister} fullWidth>
        Зарегистрироваться
      </Button>
    </Box>
  );
};

export default Register;
